import React from "react";
import { Box, Button, Stack } from "@mui/material";
import DateSelector from "./DateSelector";
import TimeSelector from "./TimeSelector";
import StyledTabs from "./Tabs";
import BranchDropdown from "./UsecaseSelector/BranchDropdown";
import UsecaseDropdown from "./UsecaseSelector/UsecaseDropdown";
import SubusecaseDropdown from "./UsecaseSelector/SubusecaseDropdown";

const LeftPanel = ({
  themeMode,
  currentTheme,
  selectedDates,
  selectedStartTime,
  selectedEndTime,
  branch,
  usecase,
  subusecase,
  selectionMode,
  onDateChange,
  onStartTimeChange,
  onEndTimeChange,
  onBranchChange,
  onUsecaseChange,
  onSubusecaseChange,
  onReset,
  onSubmit,
  onSelectionModeChange,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        color:
          themeMode === "dark"
            ? "#ffffff"
            : currentTheme.callAutomationPage.textColor,
      }}
    >
      <StyledTabs
        tabs={["Multiple Selection", "Range Selection"]}
        value={selectionMode}
        onChange={onSelectionModeChange}
      />

      <DateSelector
        selectedDates={selectedDates}
        onDateChange={onDateChange}
        placeholder="Select dates"
        isRangeMode={selectionMode === 1}
        keepCalendarOpen={true}
      />

      <TimeSelector
        selectedStartTime={selectedStartTime}
        selectedEndTime={selectedEndTime}
        onStartTimeChange={onStartTimeChange}
        onEndTimeChange={onEndTimeChange}
      />

      <Box
        sx={{
          backgroundColor: '#1C1C2E',
          borderRadius: '12px',
          padding: '16px',
          marginBottom: '16px',
        }}
      >
        <BranchDropdown
          value={branch}
          onChange={(e) => onBranchChange(e.target.value)}
        />

        <UsecaseDropdown
          branch={branch}
          value={usecase}
          onChange={(e) => onUsecaseChange(e.target.value)}
        />

        <SubusecaseDropdown
          branch={branch}
          usecase={usecase}
          value={subusecase}
          onChange={(e) => onSubusecaseChange(e.target.value)}
        />
      </Box>

      <Box 
        sx={{ 
          mt: 'auto', 
          pt: 2,
          borderTop: `1px solid ${themeMode === 'dark' ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)'}`,
        }}
      >
        <Stack direction="row" spacing={2}>
          <Button 
            variant="outlined" 
            onClick={onReset}
            sx={{
              flex: 1,
              color: themeMode === 'dark' ? '#ffffff' : currentTheme.callAutomationPage.textColor,
              borderColor: themeMode === 'dark' ? 'rgba(255, 255, 255, 0.23)' : 'rgba(0, 0, 0, 0.23)',
              '&:hover': {
                borderColor: '#ff4e3a',
                backgroundColor: 'rgba(255, 78, 58, 0.08)'
              }
            }}
          >
            Reset
          </Button>
          <Button 
            variant="contained" 
            onClick={onSubmit}
            sx={{
              flex: 1,
              backgroundColor: '#ff4e3a',
              '&:hover': {
                backgroundColor: '#e6402f'
              }
            }}
          >
            Submit
          </Button>
        </Stack>
      </Box>
    </Box>
  );
};

export default LeftPanel; 